<span class="flex w-fit items-center rounded bg-white">
  <span
    class="ag1-badge--solid"
    [class]="colorClassOverride() || 'ag1-badge-' + color()"
  >
    <div class="flex items-center gap-2">
      <ng-content />
      <span>{{ label() }}</span>
    </div>
  </span>
</span>
